import * as React from "react";
import {
  TextField as MuiTextField,
  TextFieldProps as MuiTextFieldProps
} from "@material-ui/core";
import { forwardRef } from "react";
import { useNumeralInput } from "./use-numeral-input";

interface NumeralTextFieldProps extends Omit<MuiTextFieldProps, "onChange"> {
  suffix?: string;
  format?: string;
  allowDecimals?: boolean;
  selectAllOnFocus?: boolean;
  onChange?: (rawValue: string, numericValue: number | null) => void;
  value?: string | number;
}

export const NumeralTextField = forwardRef<HTMLInputElement, NumeralTextFieldProps>(
  (props, ref) => {
    const {
      suffix = "kr",
      format = "0,0",
      allowDecimals = false,
      selectAllOnFocus = true,
      onChange,
      value = "",
      variant,
      ...other
    } = props;

    const { inputProps, inputRef } = useNumeralInput({
      suffix,
      format,
      allowDecimals,
      selectAllOnFocus,
      onChange,
      value
    });

    return (
      <MuiTextField
        ref={ref}
        inputRef={inputRef}
        variant={variant}
        {...inputProps}
        {...other}
      />
    );
  }
);

NumeralTextField.displayName = "NumeralTextField";

export default NumeralTextField;
